const MINUTE_MS = 60_000

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const FIRE_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([+-]\d{2}:\d{2})$/

const unit = (count: number, singular: string, plural: string) => (
  `${count} ${count === 1 ? singular : plural}`
)

/** Same wording as the API rule. A past instant, or a gap that rounds to zero minutes, is `due`. */
export const relativePhrase = (fire: Date, now: Date): string => {
  const gapMs = fire.getTime() - now.getTime()
  if (gapMs < 0) return 'due'

  const roundedMinutes = Math.round(gapMs / MINUTE_MS)
  if (roundedMinutes <= 0) return 'due'
  if (roundedMinutes < 60) return `in ${unit(roundedMinutes, 'minute', 'minutes')}`

  const hours = Math.floor(roundedMinutes / 60)
  const minutes = roundedMinutes % 60
  if (roundedMinutes < 48 * 60) {
    if (minutes === 0) return `in ${unit(hours, 'hour', 'hours')}`
    return `in ${unit(hours, 'hour', 'hours')} ${unit(minutes, 'minute', 'minutes')}`
  }

  const days = Math.floor(hours / 24)
  const hoursLeft = hours % 24
  if (hoursLeft === 0) return `in ${unit(days, 'day', 'days')}`
  return `in ${unit(days, 'day', 'days')} ${unit(hoursLeft, 'hour', 'hours')}`
}

/** Log shape in the schedule timezone: `Fri Oct 30 13:00:00 CET 2026`. CET is offset +1, CEST is +2. */
export const formatFireTime = (iso: string): string => {
  const match = FIRE_TIME.exec(iso)
  if (!match) return ''

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const hour = match[4]
  const minute = match[5]
  const second = match[6]
  const offset = match[7]
  const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()]
  const monthName = MONTHS[month - 1]
  if (!weekday || !monthName) return ''

  const zone = offset === '+01:00' ? 'CET' : offset === '+02:00' ? 'CEST' : offset
  const dayText = String(day).padStart(2, ' ')
  return `${weekday} ${monthName} ${dayText} ${hour}:${minute}:${second} ${zone} ${year}`
}
